import React from 'react';
export function Footer() {
  return <footer className="bg-surface py-10 px-3 border-t border-accent/15" data-id="element-68">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-69">
        <p className="font-display text-base text-accent font-bold" data-id="element-70">
          Salud en tu Plato
        </p>
        <p className="text-xs text-muted/70" data-id="element-71">
          © Salud en tu Plato 2026 — Todos los derechos reservados. Prohibida
          la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}